import React, { ReactNode } from 'react';
import { Breakpoints } from '@volkswagen-onehub/components-core';
import {
  ContentListStyled,
  ContentListBoxStyled
} from './styles';
import {
  TextAppearance,
  TextColor,
  TextCustom,
  TextLineHeight,
  TextSize,
  TextWeight,
} from '@vw-marketing/us-components';

interface ContentListProps {
  title?: string | React.JSX.Element[];
  children: ReactNode
}

const ContentList: React.FC<ContentListProps> = ({
  title,
  children,
}) => {
  return (
    <ContentListStyled>
      {title && <TextCustom
        appearance={TextAppearance.label150}
        style={{
          [Breakpoints.default]: {
            fontSize: TextSize.TextSize20,
            fontWeight: TextWeight.bold,
            color: TextColor.primary,
            lineHeight: TextLineHeight.TextLineHeight32,
          },
          [Breakpoints.b1920]: {
            fontSize: TextSize.TextSize24,
            fontWeight: TextWeight.bold,
            color: TextColor.primary,
            lineHeight: TextLineHeight.TextLineHeight36,
          },
        }}
      >
        {title}
      </TextCustom>}
      <ContentListBoxStyled>
        {children}
      </ContentListBoxStyled>
    </ContentListStyled>
  );
};
export default ContentList;
